<template>
    <v-card>
        <v-toolbar dense color="teal lighten-3">
            <v-toolbar-title>
                <v-icon>settings</v-icon>&nbsp; Configuración de Usuario
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn :disabled="bEdit" text class="text-none" @click="onEdit">Editar</v-btn>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled="bEdit" text @click="onClose" v-on="on">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cerrar</span>
                </v-tooltip>
            </v-toolbar-items>

            <!-- Menú lateral para dispositivos con ventanas chicas: -->
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="hidden-md-and-up">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list color="grey lighten-4">
                    <v-list-item :disabled="bEdit" @click="onEdit">
                        <v-list-item-title>
                            <v-icon color="teal darken-1">edit</v-icon>&nbsp; Editar
                        </v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item :disabled="bEdit" @click="onClose">
                        <v-list-item-title>
                            <v-icon color="teal darken-1">close</v-icon>&nbsp; Cerrar
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-container fluid>
            <v-layout row>
                <v-flex xs12>
                    <v-tabs
                        color="orange accent-4"
                        show-arrows
                        @change="onChangeTab"
                        v-model="tabIndex"
                    >
                        <!-- <v-tab class="text-none">
                            <v-icon left>assignment</v-icon>Funciones
                        </v-tab>-->
                        <v-tab class="text-none">
                            <v-icon left>star_border</v-icon>Roles
                        </v-tab>
                        <v-tab class="text-none">
                            <v-icon left>business_center</v-icon>Unidades de Negocio
                        </v-tab>
                        <v-tab class="text-none">
                            <v-icon left>party_mode</v-icon>Direcciones
                        </v-tab>

                        <!--****************************** Tab Funciones: ************************************* -->
                        <!-- <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row>
                                            <v-flex xs12>
                                                <v-btn
                                                    :disabled="!bEdit"
                                                    text
                                                    class="text-none"
                                                    @click="onAssignFunctions"
                                                    color="orange accent-4"
                                                >Asignar Funciones</v-btn>
                                                <v-btn
                                                    text
                                                    class="text-none"
                                                    @click="onRenameFunction"
                                                    color="orange accent-4"
                                                    :disabled="!bEdit || selectedUserFunction.length === 0"
                                                >Renombrar Función</v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap justify-space-between>
                                            <v-flex xs12>
                                                <v-data-table
                                                    :headers="headerAssignedFunctions"
                                                    :items="userFunctions"
                                                    single-select
                                                    item-key="funcionesid"
                                                    :show-select="bEdit"
                                                    class="elevation-1"
                                                    dense
                                                    fixed-header
                                                    :height="dataTableHeight"
                                                    :loading="waitCursor"
                                                    loading-text="Cargando datos..."
                                                    v-model="selectedUserFunction"
                                                    locale="es-MX"
                                                    :items-per-page="30"
                                                    no-data-text="No se han asignado funciones a este usuario."
                                                    :footer-props="{
                                                        'showFirstLastPage': true,
                                                        'items-per-page-text': 'Funciones por página:',
                                                        'items-per-page-all-text': 'Todas'
                                                        }"
                                                ></v-data-table>
                                            </v-flex>
                        </v-layout>-->
                        <!-- Modal para asignar funciones: *********************************** -->
                        <!-- <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bAssignFunctionsDlg"
                                                persistent
                                                width="55%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Asignar Funciones al Usuario</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>assignment</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row>
                                                                <v-flex xs12>
                                                                    <v-data-table
                                                                        :headers="headerFunctions"
                                                                        :items="functionsExt"
                                                                        item-key="funcionesid"
                                                                        show-select
                                                                        class="elevation-1"
                                                                        dense
                                                                        fixed-header
                                                                        height="350px"
                                                                        :loading="waitCursor"
                                                                        loading-text="Cargando datos..."
                                                                        v-model="userFunctions"
                                                                        locale="es-MX"
                                                                        :items-per-page="30"
                                                                        :footer-props="{
                                                                                        'showFirstLastPage': true,
                                                                                        'items-per-page-text': 'Funciones por página:',
                                                                                        'items-per-page-all-text': 'Todas'
                                                                                        }"
                                                                    ></v-data-table>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="bAssignFunctionsDlg = false"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="onCancelAssignFunctions"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                        </v-layout>-->
                        <!-- Termina Modal para asignar funciones *************************** -->
                        <!-- Modal para renombrar funciones: *********************************** -->
                        <!-- <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bRenameFunctionDlg"
                                                persistent
                                                width="35%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Renombrar Función Seleccionada</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>assignment</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        label="Nombre original"
                                                                        type="text"
                                                                        color="orange accent-4 "
                                                                        readonly
                                                                        v-model="tempOriginalName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        autofocus
                                                                        label="Nombre para el usuario"
                                                                        type="text"
                                                                        color="orange accent-4"
                                                                        v-model="tempNewName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="onSaveFunctionName"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="bRenameFunctionDlg = false"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                        </v-layout>-->
                        <!-- Termina Modal para renombrar funciones *************************** -->
                        <!-- </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>-->
                        <!--****************************** Tab Roles: ************************************* -->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row>
                                            <v-flex xs12>
                                                <v-btn
                                                    :disabled="!bEdit"
                                                    text
                                                    class="text-none"
                                                    @click="onAssignRoles"
                                                    color="orange accent-4"
                                                >Asignar Roles</v-btn>
                                                <v-btn
                                                    text
                                                    class="text-none"
                                                    @click="onRenameRole"
                                                    color="orange accent-4"
                                                    :disabled="!bEdit || selectedUserRole.length === 0"
                                                >Renombrar Rol</v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap justify-space-between>
                                            <v-flex xs12>
                                                <v-data-table
                                                    :headers="headerAssignedRoles"
                                                    :items="userRoles"
                                                    single-select
                                                    item-key="rolesid"
                                                    :show-select="bEdit"
                                                    class="elevation-1"
                                                    dense
                                                    fixed-header
                                                    :height="dataTableHeight"
                                                    :loading="waitCursor"
                                                    loading-text="Cargando datos..."
                                                    v-model="selectedUserRole"
                                                    locale="es-MX"
                                                    :items-per-page="30"
                                                    no-data-text="No se han asignado roles a este usuario."
                                                    :footer-props="{
                                                        'showFirstLastPage': true,
                                                        'items-per-page-text': 'Roles por página:',
                                                        'items-per-page-all-text': 'Todos'
                                                        }"
                                                ></v-data-table>
                                            </v-flex>
                                        </v-layout>
                                        <!-- Modal para asignar roles: *********************************** -->
                                        <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bAssignRolesDlg"
                                                persistent
                                                width="55%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Asignar Roles al Usuario</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>star_border</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row>
                                                                <v-flex xs12>
                                                                    <v-data-table
                                                                        :headers="headerRoles"
                                                                        :items="rolesExt"
                                                                        item-key="rolesid"
                                                                        show-select
                                                                        class="elevation-1"
                                                                        dense
                                                                        fixed-header
                                                                        height="350px"
                                                                        :loading="waitCursor"
                                                                        loading-text="Cargando datos..."
                                                                        v-model="userRoles"
                                                                        locale="es-MX"
                                                                        :items-per-page="30"
                                                                        :footer-props="{
                                                                                        'showFirstLastPage': true,
                                                                                        'items-per-page-text': 'Roles por página:',
                                                                                        'items-per-page-all-text': 'Todos'
                                                                                        }"
                                                                    ></v-data-table>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="bAssignRolesDlg = false"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="onCancelAssignRoles"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-layout>
                                        <!-- Termina Modal para asignar roles *************************** -->
                                        <!-- Modal para renombrar roles: *********************************** -->
                                        <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bRenameRoleDlg"
                                                persistent
                                                width="35%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Renombrar Rol Seleccionado</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>star_border</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        label="Nombre original"
                                                                        type="text"
                                                                        color="orange accent-4 "
                                                                        readonly
                                                                        v-model="tempOriginalName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        autofocus
                                                                        label="Nombre para el usuario"
                                                                        type="text"
                                                                        color="orange accent-4"
                                                                        v-model="tempNewName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="onSaveRoleName"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="bRenameRoleDlg = false"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-layout>
                                        <!-- Termina Modal para renombrar roles *************************** -->
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <!--****************************** Tab Unidades de Negocio: ************************************* -->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row>
                                            <v-flex xs12>
                                                <v-btn
                                                    :disabled="!bEdit"
                                                    text
                                                    class="text-none"
                                                    @click="onAssignBusinessUnits"
                                                    color="orange accent-4"
                                                >Asignar Unidades de Negocio</v-btn>
                                                <v-btn
                                                    text
                                                    class="text-none"
                                                    @click="onRenameBusinessUnit"
                                                    color="orange accent-4"
                                                    :disabled="!bEdit || selectedUserBusinessUnit.length === 0"
                                                >Renombrar Unidad de Negocio</v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap justify-space-between>
                                            <v-flex xs12>
                                                <v-data-table
                                                    color="orange accent-4"
                                                    :headers="headerAssignedBusinessUnits"
                                                    :items="userBusinessUnits"
                                                    single-select
                                                    item-key="unidadnegocioid"
                                                    :show-select="bEdit"
                                                    class="elevation-1"
                                                    dense
                                                    fixed-header
                                                    :height="dataTableHeight"
                                                    :loading="waitCursor"
                                                    loading-text="Cargando datos..."
                                                    v-model="selectedUserBusinessUnit"
                                                    locale="es-MX"
                                                    :items-per-page="15"
                                                    no-data-text="No se han asignado unidades de negocio a este usuario."
                                                    :footer-props="{
                                                        'showFirstLastPage': true,
                                                        'items-per-page-text': 'Unidades por página:',
                                                        'items-per-page-all-text': 'Todas'
                                                        }"
                                                ></v-data-table>
                                            </v-flex>
                                        </v-layout>
                                        <!-- Modal para asignar Unidades de Negocio: *********************************** -->
                                        <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bAssignBusinessUnitsDlg"
                                                persistent
                                                width="55%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Asignar Unidades al Usuario</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>business_center</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row>
                                                                <v-flex xs12>
                                                                    <v-data-table
                                                                        :headers="headerBusinessUnits"
                                                                        :items="businessUnitsExt"
                                                                        item-key="unidadnegocioid"
                                                                        show-select
                                                                        class="elevation-1"
                                                                        dense
                                                                        fixed-header
                                                                        height="350px"
                                                                        :loading="waitCursor"
                                                                        loading-text="Cargando datos..."
                                                                        v-model="userBusinessUnits"
                                                                        locale="es-MX"
                                                                        :items-per-page="30"
                                                                        :footer-props="{
                                                                                        'showFirstLastPage': true,
                                                                                        'items-per-page-text': 'Unidades por página:',
                                                                                        'items-per-page-all-text': 'Todas'
                                                                                        }"
                                                                    ></v-data-table>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="bAssignBusinessUnitsDlg = false"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="onCancelAssignBusinessUnits"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-layout>
                                        <!-- Termina Modal para asignar unidades de negocio *************************** -->
                                        <!-- Modal para renombrar unidades de negocio: *********************************** -->
                                        <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bRenameBusinessUnitDlg"
                                                persistent
                                                width="35%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Renombrar Unidad Seleccionada</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>business_center</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        label="Nombre original"
                                                                        type="text"
                                                                        color="orange accent-4 "
                                                                        readonly
                                                                        v-model="tempOriginalName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        autofocus
                                                                        label="Nombre para el usuario"
                                                                        type="text"
                                                                        color="orange accent-4"
                                                                        v-model="tempNewName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="onSaveBusinessUnitName"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="bRenameBusinessUnitDlg = false"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-layout>
                                        <!-- Termina Modal para renombrar unidades de negocio *************************** -->
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <!--****************************** Tab Direcciones: ************************************* -->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-container fluid>
                                        <v-layout row>
                                            <v-flex xs12>
                                                <v-btn
                                                    :disabled="!bEdit"
                                                    text
                                                    class="text-none"
                                                    @click="onAssignDepartments"
                                                    color="orange accent-4"
                                                >Asignar Direcciones</v-btn>
                                                <v-btn
                                                    text
                                                    class="text-none"
                                                    @click="onRenameDepartment"
                                                    color="orange accent-4"
                                                    :disabled="!bEdit || selectedUserDepartment.length === 0"
                                                >Renombrar Dirección</v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap justify-space-between>
                                            <v-flex xs12>
                                                <v-data-table
                                                    :headers="headerAssignedDepartments"
                                                    :items="userDepartments"
                                                    single-select
                                                    item-key="direccionesid"
                                                    :show-select="bEdit"
                                                    class="elevation-1"
                                                    dense
                                                    fixed-header
                                                    :height="dataTableHeight"
                                                    :loading="waitCursor"
                                                    loading-text="Cargando datos..."
                                                    v-model="selectedUserDepartment"
                                                    locale="es-MX"
                                                    :items-per-page="15"
                                                    no-data-text="No se han asignado direcciones a este usuario."
                                                    :footer-props="{
                                                        'showFirstLastPage': true,
                                                        'items-per-page-text': 'Direcciones por página:',
                                                        'items-per-page-all-text': 'Todas'
                                                        }"
                                                ></v-data-table>
                                            </v-flex>
                                        </v-layout>
                                        <!-- Modal para asignar Direcciones: *********************************** -->
                                        <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bAssignDepartmentsDlg"
                                                persistent
                                                width="55%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Asignar Direcciones al Usuario</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>party_mode</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row>
                                                                <v-flex xs12>
                                                                    <v-data-table
                                                                        :headers="headerDepartments"
                                                                        :items="departmentsExt"
                                                                        item-key="direccionesid"
                                                                        show-select
                                                                        class="elevation-1"
                                                                        dense
                                                                        fixed-header
                                                                        height="350px"
                                                                        :loading="waitCursor"
                                                                        loading-text="Cargando datos..."
                                                                        v-model="userDepartments"
                                                                        locale="es-MX"
                                                                        :items-per-page="30"
                                                                        :footer-props="{
                                                                                        'showFirstLastPage': true,
                                                                                        'items-per-page-text': 'Direccciones por página:',
                                                                                        'items-per-page-all-text': 'Todas'
                                                                                        }"
                                                                    ></v-data-table>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="bAssignDepartmentsDlg = false"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="onCancelAssignDepartments"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-layout>
                                        <!-- Termina Modal para asignar Direcciones *************************** -->
                                        <!-- Modal para renombrar Direcciones: *********************************** -->
                                        <v-layout row justify-center>
                                            <v-dialog
                                                v-model="bRenameDepartmentDlg"
                                                persistent
                                                width="35%"
                                            >
                                                <v-card class="grey lighten-4">
                                                    <v-toolbar dense color="teal lighten-3">
                                                        <v-toolbar-title
                                                            class="my-list-title"
                                                        >Renombrar Dirección Seleccionada</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-icon>party_mode</v-icon>
                                                    </v-toolbar>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        label="Nombre original"
                                                                        type="text"
                                                                        color="orange accent-4 "
                                                                        readonly
                                                                        v-model="tempOriginalName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row justify-center>
                                                                <v-flex
                                                                    xs12
                                                                    md11
                                                                    class="text-center"
                                                                >
                                                                    <v-text-field
                                                                        name="originalName"
                                                                        autofocus
                                                                        label="Nombre para el usuario"
                                                                        type="text"
                                                                        color="orange accent-4"
                                                                        v-model="tempNewName"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            color="teal darken-3"
                                                            class="text-none"
                                                            text
                                                            @click="onSaveDepartmentName"
                                                        >OK</v-btn>
                                                        <v-btn
                                                            color="pink darken-1"
                                                            class="text-none"
                                                            text
                                                            @click="bRenameDepartmentDlg = false"
                                                        >Cancelar</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </v-layout>
                                        <!-- Termina Modal para renombrar Direcciones *************************** -->
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
            <v-layout v-if="bEdit" align-center justify-end row fill-height>
                <v-flex xs12 sm8 class="text-xs-center text-end">
                    <v-btn
                        color="teal darken-3"
                        class="text-none"
                        text
                        @click="onSave"
                        :disabled="!bEdit"
                    >OK</v-btn>
                    <v-btn
                        color="pink darken-1"
                        class="text-none"
                        text
                        @click="onCancel"
                        :disabled="!bEdit"
                    >Cancelar</v-btn>
                </v-flex>
            </v-layout>
            <v-overlay :value="waitCursor">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-container>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'UserConfig',
    data() {
        return {
            tabIndex: null,
            bEdit: false,

            // bAssignFunctionsDlg: false,
            // bRenameFunctionDlg: false,
            // selectedUserFunction: [], //Indica la función seleccionada para renombrar.

            bAssignRolesDlg: false,
            bRenameRoleDlg: false,
            selectedUserRole: [], //Indica el rol seleccionado para renombrar.

            bAssignBusinessUnitsDlg: false,
            bRenameBusinessUnitDlg: false,
            selectedUserBusinessUnit: [], //Indica la unidad de negocios seleccionada para renombrar.

            bAssignDepartmentsDlg: false,
            bRenameDepartmentDlg: false,
            selectedUserDepartment: [], //Indica la dirección seleccionada para renombrar.

            tempOriginalName: '', //String para el nombre del campo original.
            tempNewName: '', //String temporal para guardar los nombres personalizados.

            // headerAssignedFunctions: [
            //     {
            //         text: 'Funciones Asignadas',
            //         value: 'funcion',
            //         align: 'start'
            //     },
            //     {
            //         text: 'Nombre para el Usuario',
            //         value: 'nombre',
            //         align: 'start'
            //     },
            //     { text: 'Contexto', value: 'contexto', align: 'end' },
            //     { text: 'Desafío', value: 'desafio', align: 'end' }
            // ],
            // headerFunctions: [
            //     { text: 'Función', value: 'funcion', align: 'start' },
            //     {
            //         text: 'Nombre para el Usuario',
            //         value: 'nombre',
            //         align: 'start'
            //     },
            //     { text: 'Contexto', value: 'contexto', align: 'end' },
            //     { text: 'Desafío', value: 'desafio', align: 'end' }
            // ],

            headerAssignedRoles: [
                { text: 'Roles Asignados', value: 'rol', align: 'left' },
                {
                    text: 'Nombre para el Usuario',
                    value: 'nombre',
                    align: 'left'
                },
                { text: 'Talento', value: 'talento', align: 'center' },
                { text: 'Contribución', value: 'contribucion', align: 'right' },
                { text: 'Total', value: 'total', align: 'right' },
                {
                    text: 'Tamaño Aplicación',
                    value: 'tamanoaplicacion',
                    align: 'right'
                },
                { text: 'Factor 1', value: 'factor1', align: 'left' },
                { text: 'Factor 2', value: 'factor2', align: 'left' }
            ],

            headerRoles: [
                { text: 'Rol', value: 'rol', align: 'left' },
                {
                    text: 'Nombre para el Usuario',
                    value: 'nombre',
                    align: 'left'
                },
                { text: 'Talento', value: 'talento', align: 'center' },
                { text: 'Contribución', value: 'contribucion', align: 'right' },
                { text: 'Total', value: 'total', align: 'right' },
                {
                    text: 'Tamaño Aplicación',
                    value: 'tamanoaplicacion',
                    align: 'right'
                },
                { text: 'Factor 1', value: 'factor1', align: 'left' },
                { text: 'Factor 2', value: 'factor2', align: 'left' }
            ],

            headerAssignedBusinessUnits: [
                { text: 'Unidades Asignadas', value: 'nombre', align: 'start' },
                {
                    text: 'Nombre para el Usuario',
                    value: 'nombreUsuario',
                    align: 'start'
                }
            ],

            headerBusinessUnits: [
                { text: 'Unidad de Negocio', value: 'nombre', align: 'start' },
                {
                    text: 'Nombre para el Usuario',
                    value: 'nombreUsuario',
                    align: 'start'
                }
            ],

            headerAssignedDepartments: [
                {
                    text: 'Direcciones Asignadas',
                    value: 'direccion',
                    align: 'start'
                },
                {
                    text: 'Nombre para el Usuario',
                    value: 'nombreUsuario',
                    align: 'start'
                }
            ],

            headerDepartments: [
                { text: 'Dirección', value: 'direccion', align: 'start' },
                {
                    text: 'Nombre para el Usuario',
                    value: 'nombreUsuario',
                    align: 'start'
                }
            ]
        };
    },
    props: {
        userID: Number,
        companyID: Number
    },
    methods: {
        onEdit() {
            this.bEdit = true;
        },
        onSave() {
            //console.log('onSave, userID = ', this.userID);
            this.$store.dispatch('saveUserConfig', this.userID);
            this.bEdit = false;
        },
        onCancel() {
            const user = {
                userID: this.userID,
                companyID: this.companyID
            };
            //this.$store.dispatch('fetchUserConfiguration', user);
            // this.selectedUserFunction = [];
            this.selectedUserRole = [];
            this.selectedUserBusinessUnit = [];
            this.selectedUserDepartment = [];
            this.bEdit = false;
        },
        onClose() {
            this.$store.dispatch('updateUserConfigOK', false);
        },
        onChangeTab() {
            //console.log('tab changed, tabIndex = ', this.tabIndex);
        },
        // onAssignFunctions() {
        //     this.bAssignFunctionsDlg = true;
        // },
        onAssignRoles() {
            this.bAssignRolesDlg = true;
        },
        onAssignBusinessUnits() {
            this.bAssignBusinessUnitsDlg = true;
        },
        onAssignDepartments() {
            this.bAssignDepartmentsDlg = true;
        },

        // onRenameFunction() {
        //     this.tempOriginalName = this.selectedUserFunction[0].funcion;
        //     this.tempNewName = this.selectedUserFunction[0].nombre;
        //     this.bRenameFunctionDlg = true;
        // },
        onRenameRole() {
            this.tempOriginalName = this.selectedUserRole[0].rol;
            this.tempNewName = this.selectedUserRole[0].nombre;
            this.bRenameRoleDlg = true;
        },
        onRenameBusinessUnit() {
            this.tempOriginalName = this.selectedUserBusinessUnit[0].nombre;
            this.tempNewName = this.selectedUserBusinessUnit[0].nombreUsuario;
            this.bRenameBusinessUnitDlg = true;
        },
        onRenameDepartment() {
            this.tempOriginalName = this.selectedUserDepartment[0].direccion;
            this.tempNewName = this.selectedUserDepartment[0].nombreUsuario;
            this.bRenameDepartmentDlg = true;
        },

        // onSaveFunctionName() {
        //     var i;
        //     for (i = 0; i < this.userFunctions.length; i++) {
        //         if (
        //             this.userFunctions[i].funcionesid ===
        //             this.selectedUserFunction[0].funcionesid
        //         ) {
        //             this.userFunctions[i].nombre = this.tempNewName;
        //             break;
        //         }
        //     }
        //     this.bRenameFunctionDlg = false;
        // },
        onSaveRoleName() {
            var i;
            for (i = 0; i < this.userRoles.length; i++) {
                if (
                    this.userRoles[i].rolesid ===
                    this.selectedUserRole[0].rolesid
                ) {
                    this.userRoles[i].nombre = this.tempNewName;
                    break;
                }
            }
            this.bRenameRoleDlg = false;
        },
        onSaveBusinessUnitName() {
            var i;
            for (i = 0; i < this.userBusinessUnits.length; i++) {
                if (
                    this.userBusinessUnits[i].unidadnegocioid ===
                    this.selectedUserBusinessUnit[0].unidadnegocioid
                ) {
                    this.userBusinessUnits[i].nombreUsuario = this.tempNewName;
                    break;
                }
            }
            this.bRenameBusinessUnitDlg = false;
        },
        onSaveDepartmentName() {
            var i;
            for (i = 0; i < this.userDepartments.length; i++) {
                if (
                    this.userDepartments[i].direccionesid ===
                    this.selectedUserDepartment[0].direccionesid
                ) {
                    this.userDepartments[i].nombreUsuario = this.tempNewName;
                    break;
                }
            }
            this.bRenameDepartmentDlg = false;
        },

        onItemSelected() {
            console.log('Item Selected');
        },

        // onCancelAssignFunctions() {
        //     this.$store.dispatch('restoreUserFunctions');
        //     this.bAssignFunctionsDlg = false;
        // },
        onCancelAssignRoles() {
            this.$store.dispatch('restoreUserRoles');
            this.bAssignRolesDlg = false;
        },
        onCancelAssignBusinessUnits() {
            this.$store.dispatch('restoreUserBusinessUnits');
            this.bAssignBusinessUnitsDlg = false;
        },
        onCancelAssignDepartments() {
            this.$store.dispatch('restoreUserDepartments');
            this.bAssignDepartmentsDlg = false;
        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            // 'functionsExt',
            'rolesExt',
            'businessUnitsExt',
            'departmentsExt'
        ]),
        // userFunctions: {
        //     get() {
        //         return this.$store.getters.userFunctions;
        //     },
        //     set(userFunctions) {
        //         this.$store.dispatch('updateUserFunctions', userFunctions);
        //     }
        // },
        userRoles: {
            get() {
                return this.$store.getters.userRoles;
            },
            set(userRoles) {
                this.$store.dispatch('updateUserRoles', userRoles);
            }
        },
        userBusinessUnits: {
            get() {
                return this.$store.getters.userBusinessUnits;
            },
            set(userBusinessUnits) {
                this.$store.dispatch(
                    'updateUserBusinessUnits',
                    userBusinessUnits
                );
            }
        },
        userDepartments: {
            get() {
                return this.$store.getters.userDepartments;
            },
            set(userDepartments) {
                this.$store.dispatch('updateUserDepartments', userDepartments);
            }
        },
        dataTableHeight() {
            var height = '300px';
            if (this.bEdit) {
                height = '315px';
            } else {
                height = '350px';
            }
            return height;
        }
    }
};
</script>

<style scoped>
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}

.my-list-item {
    min-height: 30px !important;
}
</style>